/* Copyright (c) Trimble Inc. All rights reserved. */

import type { ActionStatusType, AsyncActionState } from './AsyncAction.type';
import { ACTION_STATUS } from './AsyncAction.type';

export const defaultState: AsyncActionState = {
  status: ACTION_STATUS.INIT,
  init: false,
  loading: false,
  intermediate: false,
  loaded: false,
  error: undefined,
};

export interface AsyncStateActionType {
  type: ActionStatusType;
  payload?: unknown;
}
export const AsyncActionReducer = (
  state: AsyncActionState = defaultState,
  action: AsyncStateActionType = {
    type: ACTION_STATUS.INIT,
    payload: null,
  }
) => {
  return {
    status: action.type ?? state.status,
    value:
      action.type === ACTION_STATUS.INIT ? null : (
        action.type === ACTION_STATUS.INTERMEDIATE ? action.payload : state.value),
    init: action.type === ACTION_STATUS.INIT,
    loading: action.type === ACTION_STATUS.LOADING,
    intermediate: action.type === ACTION_STATUS.INTERMEDIATE,
    loaded: action.type === ACTION_STATUS.LOADED,
    error:
      action.type === ACTION_STATUS.INIT
      ? null : action.type === ACTION_STATUS.LOADING
        ? null
        : action.type === ACTION_STATUS.ERROR
        ? action.payload
        : state.error,
  };
};
